// extracted by mini-css-extract-plugin
export default {"overlay":"vx-z","bodyOpen":"wx-z","content":"xx-z","header":"yx-z","close":"zx-z","closeNoHeading":"Ax-z"};